module.exports = __webpack_public_path__ + "img/2.63a5f1d8.png";